
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningHeavySleetShowersPolartwilight as ObiLightningHeavySleetShowersPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-heavy-sleet-showers-polartwilight.js';
 
 
 

 
 export const ObiLightningHeavySleetShowersPolartwilight = createComponent({
   react: React,
   tagName: 'obi-lightning-heavy-sleet-showers-polartwilight',
   elementClass: ObiLightningHeavySleetShowersPolartwilightElement,
   events: {
     
   }
  });
 
 